'use strict';

const {TableAPIController, Table} = require('../components/tables');
const FiltersHash = require('../components/filters-hash');
const {CollapsiblePane, mix} = require('../components/configure-pane');
const toggles = require('../components/toggles');
const Controller = require('../shared/controller');

const PAGE_TEMPLATE = require('../templates/browsers.html');
const CONFIGURE_PANE_TEMPLATE = require('../templates/configure-pane-filters-hash.html');
const EVENT_TYPES_TEMPLATE = require('../templates/browsers-event-types.html');

const EVENT_TYPES = new Map([
	['Validate', ['Validate', 'Success']],
	['Token', ['Token', 'Grant']],
	['Failed Browser Check', ['Validate', 'Blocked', 'failedBrowserCheck']],
	['Not Supported', ['Validate', 'Blocked', 'noSuitableModesSupported']],
]);
const DEFAULT_EVENT_TYPE = 'Validate';

class EventTypesToggles extends toggles.Toggles {
	constructor(options) {
		options = Object.assign({notEmpty: true, default: false}, options);
		super(EVENT_TYPES, options);
		this.toggleOn(DEFAULT_EVENT_TYPE);
	}
}

class EventTogglesController extends toggles.PopupToggles {
	constructor(options) {
		super({toggles: new EventTypesToggles()}, ... arguments);
	}

	getItems() {
		let types = [...this.toggles.toggledOn('key')];
		return types;
	}

	getQueryParams() {
		let types = [...this.toggles.toggledOn('value')];
		return {type: types};
	}
}


class EventTypesController extends FiltersHash {
	constructor(options) {
		super({
			filters: [['environment', 'Service'], ['ClientMarket', 'Market']],
			template: EVENT_TYPES_TEMPLATE
		}, ... arguments);
		let etController = new EventTogglesController();
		this._toggles.set('eventTypes', etController.toggles);
		this._controllers.set('eventTypes', etController);
	}
}

class BrowsersPageConfigurePane extends mix(CollapsiblePane, 'TIME_RANGE') {
	constructor(options) {
		super(options);
		this._template = CONFIGURE_PANE_TEMPLATE;
		this.initTimeRange();
		this.addComponent('filters', new EventTypesController());
		// this.initFiltersHash({filters: ['environment', ['Market', 'ClientMarket']]});
	}
}

class UserAgentsTableAPIController extends TableAPIController {
	createTable() {
		return new Table(this.container, {
			columns: [
				{key: 'family', title: 'Family'},
				{key: 'count', title: 'Count'},
				{key: 'percentage', title: 'Percentage', numberFormat: '0.0%'}
			]
		});
	}

	getRows(options) {
		let data, top, total;
		try {
			data = options.data.data;
			({top, total} = data);
		} catch (err) {
			return null;
		}
		if (!data || !top || !top.length || !total) {
			return null;
		}

		let totalCount = total.count;
		let rows = [];
		for (let d of top) {
			let {family, count} = d;
			rows.push({family, count, percentage: count / totalCount});
		}
		rows.push({family: 'Total', count: totalCount});
		return rows;
	}
}

class BrowsersPage extends Controller {
	constructor(options) {
		super({template: PAGE_TEMPLATE}, options);
		this.filters = new BrowsersPageConfigurePane({filters: ['environment', ["Market", "ClientMarket"]]});
		this.browsersTable = new UserAgentsTableAPIController({method: 'user-agents/top-families'});
		this.osTable = new UserAgentsTableAPIController({method: 'user-agents/os'});
		this.deviceTable = new UserAgentsTableAPIController({method: 'user-agents/device'});
	}

	render(options) {
		let self = this;
		return super.render(options)
			.then(function () {
				let c = self.container;
				let filtersContainer = c.querySelector('#filters');
				let browsersTableContainer = c.querySelector('#browsers');
				let osTableContainer = c.querySelector('#os');
				let deviceTableContainer = c.querySelector('#device');
				return self.filters.render({container: filtersContainer})
					.then(function () {
						let params = self.filters.getQueryParams();
						return Promise.all([
							self.browsersTable.load({container: browsersTableContainer, params}),
							self.osTable.load({container: osTableContainer, params}),
							self.deviceTable.load({container: deviceTableContainer, params})
						]);
					})
					.then(function () {
						let reload = self.reloadData.bind(self);
						self.filters.on('cm:update', reload);
						return options;
					});
			});
	}

	reloadData() {
		let params = this.filters.getQueryParams();
		Promise.all([
			this.browsersTable.reload({params}),
			this.osTable.reload({params}),
			this.deviceTable.reload({params})
		])
			.catch(function (err) {
				console.error(err);
				return;
			});
	}
}

module.exports = BrowsersPage;
